import { Box } from 'components/Box';
import { TrackedPrimaryButtonLink } from 'components/Button';
import { Flex } from 'components/Flex';
import { Hero } from 'components/Hero';
import { RichTextHeadline } from 'components/Text/RichTextHeadline';
import { CmsApiCtaHeroBlockData } from 'modules/cms/api/types/CmsApiCtaHero';

import { cmsCtaHeroBlockPropsByLayout } from './cmsCtaHeroBlockPropsByLayout';

type Props = {
  data: CmsApiCtaHeroBlockData;
  isPageHeader?: boolean;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsCtaHeroBlock({
  data: { buttonText, buttonUrl, text, image, withOverlay, layout },
  isPageHeader,
  blockIndex,
  pageUpdated,
}: Props) {
  const { imageHeight, minHeight, py, mb } =
    cmsCtaHeroBlockPropsByLayout[layout];

  return (
    <Hero
      withOverlay={withOverlay}
      heroImage={image}
      imageHeight={imageHeight}
      data-qa-id="call-to-action-hero"
      minHeight={minHeight}
      py={py}
      mb={mb}
    >
      <Box maxWidth="768px" m="0 auto" px="20px">
        <RichTextHeadline
          color="white"
          textAlign="center"
          tag={isPageHeader ? 'h1' : undefined}
          styleAs={isPageHeader ? 'h2' : undefined}
          $reverseUnderline
          $noMarginBottom={!(buttonUrl && buttonText)}
        >
          {text}
        </RichTextHeadline>
      </Box>

      {buttonUrl && buttonText && (
        <Flex>
          <TrackedPrimaryButtonLink
            href={buttonUrl}
            eventName="CMS Block"
            eventProperties={{
              block_position: blockIndex,
              block_type: 'Call to Action Hero',
              cta_type: 'Button',
              button_text: buttonText,
              page_updated: pageUpdated,
            }}
          >
            {buttonText}
          </TrackedPrimaryButtonLink>
        </Flex>
      )}
    </Hero>
  );
}
